import routePath from '@src/lib/routePath'

const root = `/retailer/content/:retailerAccountSlug/all/`
const base = `/retailer/content/:retailerAccountSlug/all/:activeTab?`
const legacyBase = `/retailer/content/:retailerAccountSlug/:brandSlug`

const campaignContentPaths = {
  root: routePath(root),
  index: routePath(base),
  activatePaidCampaign: routePath(`${base}/paid-ad/:campaignId` as const),
}

export const legacyCampaignContentPaths = {
  root: routePath(legacyBase), //Backwards compatibility for legacy stuff
  index: routePath(legacyBase),
  activatePaidCampaign: routePath(`${legacyBase}/paid-ad/:campaignId` as const),
}

export const getCampaignContentPaths = (legacy = false) => {
  return legacy ? legacyCampaignContentPaths : campaignContentPaths
}

export default campaignContentPaths
